exports.CaseJson = {
  categoryId: null, // null if not created from category
  config: {
    education: {
      selected: false,
      maxEducations: 1,
    },
    employmentCheck: {
      selected: false,
      maxYears: 1,
      maxEmployments: 1,
    },
    uanCheck: {
      selected: false,
    },
    cvValidationCheck: {
      selected: false,
    },
    gapInEmploymentHistoryCheck: {
      selected: false,
    },
    criminalPoliceCheck: {
      selected: false,
      isPermanentAddressCheck: false,
      isResidentialAddressCheck: {
        selected: false,
        maxYears: 1,
      },
      isEmploymentAddressCheck: {
        selected: false,
        maxYears: 1,
      },
    },
    addressCheck: {
      selected: false,
      isPermanentAddressCheck: false,
      isResidentialAddressCheck: false,
    },
    digitalAddressCheck: {
      selected: false,
      isPermanentAddressCheck: false,
      isResidentialAddressCheck: false,
    },
    globalDatabaseCheck: {
      selected: false,
    },
    indianDatabaseCheck: {
      selected: false,
    },
    employmentReferenceCheck: {
      selected: false,
      maxYears: 1,
    },
    criminalCourtRecordCheck: {
      selected: false,
      isPermanentAddressCheck: false,
      isResidentialAddressCheck: {
        selected: false,
        maxYears: 10,
      },
      isEmploymentAddressCheck: {
        selected: false,
        maxYears: 1,
      },
    },
    eCourtRecordCheck: {
      selected: false,
      isPermanentAddressCheck: false,
      isResidentialAddressCheck: {
        selected: false,
        maxYears: 10,
      },
      isEmploymentAddressCheck: {
        selected: false,
        maxYears: 1,
      },
    },
    creditScoreCheck: {
      selected: false,
      isPanRequired: true,
      isResidentialAddressCheck: {
        selected: true,
      },
    },
    openWebScanCheck: {
      selected: false,
    },
    identity: {
      selected: false,
      isPanRequired: false,
      isAadhaarRequired: false,
      isDrivingLicenseRequired: false,
      isPassportRequired: false,
    },
    enableTADate: false,
    enableJoiningData: false,
    customFields: {
      value: [],
    },
  },
};



// WEBPACK FOOTER //
// ./client/app/cases/new/case.js